import { render } from "./rednoteNew.vue?vue&type=template&id=427e92c9&scoped=true"
import script from "./rednoteNew.vue?vue&type=script&lang=js"
export * from "./rednoteNew.vue?vue&type=script&lang=js"

import "./rednoteNew.vue?vue&type=style&index=0&id=427e92c9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427e92c9"]])

export default __exports__